import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

// Routes
import Home from "./pages/Home";
// import Termos from "./pages/Termos";
// import TermosProtege from "./pages/TermosProtege";
// import Locator from "./pages/Locator";
// import Chat from "./pages/Chat";
// import SuporteDigitalDashboard from "./pages/SuporteDigital/Dashboard";
// import SuporteDigitalUnSubscription from "./pages/SuporteDigital/UnSubscription";
// import Dashboard from "./pages/Dashboard";
// import AppSeguranca from "./pages/Products/Security";
// import AppFamilia from "./pages/Products/Family";
// import AppCloud from "./pages/Products/Cloud";
// import AppWifiSeguro from "./pages/Products/WifiSecurity";
// import AppHelpDesk from "./pages/Products/HelpDesk";
// import AppTransfer from "./pages/Products/Transfer";
// import AppOtimizador from "./pages/Products/Otimizador";
// import AppMeEncontra from "./pages/Products/MeEncontra";
// import AppHero from "./pages/Products/Hero";
// import Finish from "./pages/Finish";
// import ProtectParental from "./pages/Products/ProtectParental";
// import Activate from "./pages/Activate";
// import ActivateIcatu from "./pages/ActivateIcatu";
// import ActivateAgility from "./pages/ActivateAgility";
// import ActivateIcatuSicredi from "./pages/ActivateIcatuSicredi";
// import ActivateBradesco from "./pages/ActivateBradesco";

// Helpers
// import Ajuda from "./pages/Help";
// import AjudaSeguranca from "./pages/Help/Security";
// import AjudaFamilia from "./pages/Help/Family";
// import AjudaCloud from "./pages/Help/Cloud";
// import AjudaWifiSeguro from "./pages/Help/WifiSecurity";
// import AjudaHelpDesk from "./pages/Help/HelpDesk";
// import AjudaTransfer from "./pages/Help/Transfer";
// import AjudaOtimizador from "./pages/Help/Otimizador";
// import AjudaMeEncontra from "./pages/Help/MeEncontra";
// import AjudaControleDados from "./pages/Help/ControleDados";

// Webviews
// import WebviewSecurity from "./pages/Webview/Security";
// import WebviewHeroProtege from "./pages/Webview/HeroProtege";

// Partners
// import Abrint from "./pages/Partners/Abrint";
// import Brisanet from "./pages/Partners/Brisanet";
// import Neo from "./pages/Partners/Neo";
// import Sumicity from "./pages/Partners/Sumicity";
// import Positivo from "./pages/Partners/Positivo";
// import HeroProtege from "./pages/Partners/HeroProtege";
// import BrisaNet from "./pages/Webview/BrisaNet";

// import HelpMobile from "./pages/HelpMobile";

// import HelpMobileProtege from "./pages/HelpMobile/Protege";

/**
 * Authorize
 */
// import { isAuthorizated } from "./utils/Token";

// const PrivateRoute = ({ component: Component, ...rest }) => (
//   <Route
//     {...rest}
//     render={(props) =>
//       isAuthorizated(props) === true ? (
//         <Component {...props} />
//       ) : (
//         <Redirect to={{ pathname: "/", state: { from: props.location } }} />
//       )
//     }
//   />
// );

export default () => (
  <BrowserRouter basename="/">
    <Switch>
      <Route path="/" exact={true} component={Home} />
      {/* <PrivateRoute path="/cliente/:brand" exact={true} component={Dashboard} />
      <Route path="/suporte-digital" exact={true} component={Home} />
      <PrivateRoute
        path="/suporte-digital/:brand"
        exact={true}
        component={SuporteDigitalDashboard}
      />
      <PrivateRoute
        path="/suporte-digital/:brand/cancelar"
        exact={true}
        component={SuporteDigitalUnSubscription}
      />
      <Route path="/termos" exact={true} component={Termos} />
      <Route path="/termos-protege" exact={true} component={TermosProtege} />
      <Route path="/brisanet" exact={true} component={Brisanet} />
      <Route
        path="/heroprotege"
        exact={true}
        component={() => <Redirect to="/" />}
      />
      <Route path="/locator" exact={true} component={Locator} />
      <Route path="/chat" exact={true} component={Chat} />
      <Route path="/coronavirus" exact={true} component={Home} />
      <Route path="/diadasmaes" exact={true} component={Home} />
      <Route path="/plano-de-retomada" exact={true} component={Home} />
      <Route path="/doacao" exact={true} component={Home} />
      <Route path="/juntossomosmais" exact={true} component={Home} />
      <Route path="/positivo" exact={true} component={Positivo} />
      <Route path="/paisefilhos" exact={true} component={Home} />
      <Route path="/positivo" exact={true} component={Positivo} />
      <Route path="/app-seguranca" exact={true} component={AppSeguranca} />
      <Route path="/app-familia" exact={true} component={AppFamilia} />
      <Route path="/app-cloud" exact={true} component={AppCloud} />
      <Route path="/me-encontra" exact={true} component={AppMeEncontra} />
      <Route path="/app-wi-fi-seguro" exact={true} component={AppWifiSeguro} />
      <Route path="/app-help-desk" exact={true} component={AppHelpDesk} />
      <Route path="/app-transfer" exact={true} component={AppTransfer} />
      <Route path="/app-otimizador" exact={true} component={AppOtimizador} />
      <Route path="/app-hero" exact={true} component={AppHero} />
      <Route path="/ajuda" exact={true} component={Ajuda} />
      <Route path="/ajuda-seguranca" exact={true} component={AjudaSeguranca} />
      <Route path="/ajuda-familia" exact={true} component={AjudaFamilia} />
      <Route path="/ajuda-cloud" exact={true} component={AjudaCloud} />
      <Route
        path="/ajuda-wi-fi-seguro"
        exact={true}
        component={AjudaWifiSeguro}
      />
      <Route path="/ajuda-help-desk" exact={true} component={AjudaHelpDesk} />
      <Route path="/ajuda-transfer" exact={true} component={AjudaTransfer} />
      <Route
        path="/ajuda-otimizador"
        exact={true}
        component={AjudaOtimizador}
      />
      <Route
        path="/ajuda-meencontra"
        exact={true}
        component={AjudaMeEncontra}
      />
      <Route
        path="/ajuda-controledados"
        exact={true}
        component={AjudaControleDados}
      />
      <Route path="/ativar" exact={true} component={Activate} />
      <Route
        path="/sicredi_icatuseguros"
        exact={true}
        component={() => <Redirect to="/" />}
      />
      <Route path="/ativaricatu" exact={true} component={() => <Redirect to="/" />} />
      <Route path="/ativar_agility" exact={true} component={ActivateAgility} />
      <Route
        path="/ativarbradescoseguros"
        exact={true}
        component={ActivateBradesco}
      />
      <Route path="/ativarsumicity" exact={true} component={Sumicity} />
      <Route
        path="/prevenda/ativar"
        component={() => <Redirect to="/ativar" />}
      />
      <Route
        path="/vipcard/ativar"
        component={() => <Redirect to="/ativar" />}
      />
      <Route path="/neo" exact={true} component={Neo} />
      <Route path="/abrint" exact={true} component={Abrint} />
      <Route path="/abrint-oportunidade" exact={true} component={Home} />
      <Route path="/familia" exact={true} component={ProtectParental} />
      <Route path="/webview/seninha" exact={true} component={Home} />
      <Route path="/seguranca" exact={true} component={WebviewSecurity} />
      <Route path="/campanha/carnaval" exact={true} component={Home} />
      <Route path="/claroempresas" exact={true} component={Home} />
      <Route
        path="/protect-parental"
        exact={true}
        component={ProtectParental}
      />
      <Route path="/rd-parental" exact={true} component={Home} />
      <Route path="/ativarbrisanet" exact={true} component={BrisaNet} />
      <Route
        path="/assets/files/Termo-de-Uso-e-Politica-de-Privacidade-HERO.PDF"
        exact={true}
        component={Termos}
      />
      <Route
        path="/assets/conteudo-politica-privacidade/Termo-de-Uso-e-Politica-de-Privacidade-HERO.HTM"
        exact={true}
        component={Termos}
      />
      <Route
        path="/assets/files/Termo-de-Uso-e-Politica-de-Privacidade-HERO.HTM"
        exact={true}
        component={Termos}
      />
      <Route path="/help-mobile" exact={true} component={HelpMobile} />

      {/* Routes Hero Protege */}
      {/* <Route
        path="/webview/hero-protege/login"
        exact={true}
        component={() => <Redirect to="/" />}
      />
      <Route
        path="/webview/hero-protege/finish"
        exact={true}
        component={() => <Redirect to="/" />}
      />
      <Route
        path="/hero-protege"
        exact={true}
        component={() => <Redirect to="/" />}
      />
      <Route
        path="/protege"
        exact={true}
        component={() => <Redirect to="/" />}
      />
      <Route
        path="/hero-cloud-sync"
        exact={true}
        component={() => <Redirect to="/" />}
      />
      <Route
        path="/familia-by-hero"
        exact={true}
        component={() => <Redirect to="/" />}
      />
      <Route
        path="/protege/help-mobile"
        exact={true}
        component={() => <Redirect to="/" />}
      /> */}
      <Route path="*" component={() => <Redirect to="/" />} />
    </Switch>
  </BrowserRouter>
);
